import { Tabs, Tab, MenuItem, TextField } from "@mui/material";
import { Add, Close } from "@mui/icons-material";
import "./LanguageTabs.css";

/**
 * @param {object} props
 * @param {string[]} props.usedLangs
 * @param {string} props.activeLang
 * @param {(lang: string) => void} props.onChangeActiveLang
 * @param {(lang: string) => void} props.onAddLang
 * @param {(lang: string) => void} props.onRemoveLang
 * @param {{code: string, label: string}[]} props.languages
 * @param {string} [props.addLabel]
 * @param {boolean} [props.disableRemoveLast]
 * @param {boolean} [props.disabled]
 */
export default function LanguageTabs({
  usedLangs = [],
  activeLang,
  onChangeActiveLang,
  onAddLang,
  onRemoveLang,
  languages = [],
  addLabel = "Add language",
  disableRemoveLast = true,
  disabled = false,
}) {
  const used = usedLangs ?? [];
  const canRemove = !disableRemoveLast ? true : used.length > 1;
  const safeActiveLang = used.includes(activeLang) ? activeLang : used[0] ?? false;

  const available = (languages ?? []).filter((l) => !used.includes(l.code));

  return (
    <div className="lt-bar">
      <Tabs
        value={safeActiveLang}
        onChange={(_, v) => onChangeActiveLang?.(v)}
        className="lt-tabs"
        variant="scrollable"
        scrollButtons="auto"
      >
        {used.map((lang) => (
          <Tab
            key={lang}
            value={lang}
            className="lt-tab"
            disabled={disabled}
            label={
              <span className="lt-tabLabel">
                <span className="lt-tabText">{String(lang).toUpperCase()}</span>

                {canRemove && (
                  <span
                    role="button"
                    tabIndex={disabled ? -1 : 0}
                    className="lt-tabClose"
                    onClick={(e) => {
                      if (disabled) return;
                      e.stopPropagation();
                      onRemoveLang?.(lang);
                    }}
                    onKeyDown={(e) => {
                      if (disabled) return;
                      if (e.key !== "Enter" && e.key !== " ") return;
                      e.preventDefault();
                      e.stopPropagation();
                      onRemoveLang?.(lang);
                    }}
                    aria-label="remove language"
                  >
                    <Close fontSize="small" />
                  </span>
                )}
              </span>
            }
          />
        ))}
      </Tabs>

      <TextField
        select
        size="small"
        value=""
        className="lt-addSelect"
        disabled={disabled || available.length === 0}
        onChange={(e) => {
          const lang = e.target.value;
          if (!lang) return;
          onAddLang?.(lang);
        }}
        SelectProps={{ displayEmpty: true }}
      >
        <MenuItem value="" disabled>
          <span className="lt-addPlaceholder">
            <Add fontSize="small" />
            {addLabel}
          </span>
        </MenuItem>

        {available.map((l) => (
          <MenuItem key={l.code} value={l.code}>
            {l.label}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
}
